






































import { defineComponent } from "@vue/composition-api";
import Expandable from "@/components/Expandable.vue";
import { BlockLabel } from "@/models/BlockLabel";
import FeeBase from "@/models/FeeBase";
import NumberFormatter from "@/services/number.formatter";

export default defineComponent({
  name: "ConflictfundMembershipFee",
  components: {
    Expandable,
  },
  props: {
    blockId: {
      type: Number,
      required: true,
    },
    isExpanded: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      displayName: BlockLabel.ConflictfundMembershipFee,
      fee: 0,
      minimumSalaryBase: 0,
    };
  },
  computed: {
    FeeBase() {
      return FeeBase;
    },
  },
  mounted() {
    if (this.data) {
      this.fee = this.data.fee;
      this.minimumSalaryBase = this.data.minimumSalaryBase;
    }
  },
  methods: {
    expandBlock() {
      this.$emit("setBlockExpanded", this.blockId);
    },
    collapseBlock() {
      this.$emit("updateBlock", {
        blockId: this.blockId,
        type: this.$options.name,
        fee: this.fee,
        minimumSalaryBase: this.minimumSalaryBase,
      });
    },
    asCurrency: (number: number) =>
      `kr ${NumberFormatter.withThousandsSeparator(number, " ")}`,
    asPercentage(number: number) {
      return `${number}%`;
    },
  },
});
